// CSS Modules - component class name prefix: CountryDownloadBox__

<template>
  <ul :class="[$style.container, $style[this.context]]">
    <li
      v-for="(country, index) in countries"
      :key="`${index}-${country.flag}`"
      v-tippy="{
        theme: 'wika light tooltip',
        interactive: true,
        reactive: true,
        placement: 'top',
        flip: false,
        animation: 'perspective',
        animateFill: false,
        arrow: true,
        zIndex: 10002,
        html: '#countrydownloadLinks-' + index,
        trigger: isMobileDevice ? 'click' : 'mouseenter focus'
      }"
      ref="tippy"
      @init="initTippy"
      @show="forceRerender"
    >
      <img
        :src="country.flag"
        :alt="country.language"
        :title="country.language"
      />
      <ul :id="'countrydownloadLinks-' + index" :class="$style.downloadLinks">
        <li v-if="country.url && hasWishlistLink()">
          <WishListLink
            :key="`key-${componentKey}`"
            :config="{
              text: labels.wishlist,
              item: {
                types: types,
                section: section,
                title: title,
                subTitle: subTitle,
                downloads: groupedDownloadsByUrl[country.url]
              }
            }"
          />
        </li>
        <li v-if="country.ebook">
          <a :href="country.ebook" target="_blank">
            <i class="fas fa-book"></i>{{ labels.ebook }}
          </a>
        </li>
        <li v-if="country.url">
          <a :href="country.url" target="_blank">
            <i class="fas fa-file-pdf"></i>{{ labels.pdf }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import WishListLink from "../WishListLink/WishListLink.vue";
import { CountryDownloadBoxContext } from "../../globals/constants/download";
import { groupCollectionBy } from "../../utils/group";
import { sortCollectionAccordingDOWNLOADMATRIX_LANGUAGES } from "../../utils/sort";

export default {
  name: "CountryDownloadBox",
  components: {
    WishListLink
  },
  props: {
    types: {
      type: Array,
      default: () => []
    },
    title: String,
    subTitle: {
      type: String,
      default: ""
    },
    section: String,
    countries: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Object,
      default: () => {}
    },
    context: String
  },
  data() {
    return {
      componentKey: 0,
      isMobileDevice: isMobile,
      groupedDownloadsByUrl: {}
    };
  },
  methods: {
    initTippy(tippy) {
      if (tippy) {
        tippy.popper.id = "countryDownloadBoxPopper";
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    hasWishlistLink() {
      return this.context !== CountryDownloadBoxContext.WISHLIST;
    },
    sortCountries() {
      const buffer = sortCollectionAccordingDOWNLOADMATRIX_LANGUAGES(
        this.countries,
        "language",
        "asc"
      );
      const idxCurrentLanguage = buffer.findIndex(
        elem =>
          elem.language &&
          elem.language.toUpperCase() === window.currentLanguage
      );

      // Set current language at the beginning of the array
      if (idxCurrentLanguage > -1) {
        buffer.splice(0, 0, buffer.splice(idxCurrentLanguage, 1)[0]);
      }

      this.countries = buffer;
    },
    groupDownloadsByUrl() {
      /*
       * Group downloads by url to satisfy the case of one document can contain multiple languages.
       * But this document appears multiple times in data-model split by those contained languages in an array.
       * e.g. "http://www-qa.wika.dev.intern.etecture.de/media/dokumente/oi_s_11_en_de_fr_es_43531.pdf":
       * [{
       *   flag: "/media/system_cm/flags/flag_small/de.png",
       *   language: "de",
       *   url: "http://www-qa.wika.dev.intern.etecture.de/media/dokumente/oi_s_11_en_de_fr_es_43531.pdf"
       * },
       * {
       *   flag: "/media/system_cm/flags/flag_small/en.png",
       *   language: "en",
       *   url: "http://www-qa.wika.dev.intern.etecture.de/media/dokumente/oi_s_11_en_de_fr_es_43531.pdf"
       * },
       * {
       *   flag: "/media/system_cm/flags/flag_small/es.png",
       *   language: "es",
       *   url: "http://www-qa.wika.dev.intern.etecture.de/media/dokumente/oi_s_11_en_de_fr_es_43531.pdf"
       * }]
       **/
      this.groupedDownloadsByUrl = groupCollectionBy(this.countries, "url");
    }
  },
  created() {
    this.sortCountries();
  },
  beforeUpdate() {
    this.groupDownloadsByUrl();
  }
};
</script>

<style module lang="scss">
@import "./CountryDownloadBox.scss";
</style>
